import { Theme, ButtonProps, TextFieldProps } from '@mui/material'

export default function getComponentOverrides(theme: Theme) {
  return {
    MuiButton: {
      defaultProps: {
        size: 'small' as ButtonProps['size'],
        variant: 'contained' as ButtonProps['variant'],
      },
    },
    MuiDialog: {
      // Drops MUI's dark-mode elevation overlay so dialogs use a flat
      // background.paper. This has to be a style override, not a defaultProps
      // PaperProps: MUI merges `slotProps` over `paper: PaperProps` with a plain
      // spread, so any caller passing slotProps.paper would replace it and get
      // the overlay back.
      styleOverrides: { paper: { backgroundImage: 'none' } },
    },
    MuiListItemButton: {
      defaultProps: {
        sx: {
          '&.Mui-selected': { backgroundColor: theme.palette.action.selected },
          '&.Mui-selected:hover': {
            backgroundColor: theme.palette.action.selected,
          },
          '&.Mui-focusVisible': { backgroundColor: theme.palette.action.focus },
          ':hover': { backgroundColor: theme.palette.action.hover },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small' as TextFieldProps['size'],
        variant: 'filled' as TextFieldProps['variant'],
      },
    },
  }
}
